<!--
 * @Description: 需求管理 详情
 * @Author: PF
 * @Date: 2023-12-19 09:53:49
 * @LastEditors: PF
 * @LastEditTime: 2026-09-11 13:33:13
-->
<template>
  <div>
    <el-dialog class="wp90 hp93" :model-value="openDetail"  :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="6" border>
        <el-descriptions-item label="标题" label-align="right" align="left" width="100px" span="2">{{ruleForm.bt}}</el-descriptions-item>
        <el-descriptions-item label="所属菜单" label-align="right" align="left" span="4">
          <span v-if="ruleForm.sscdlj">{{ruleForm.sscdlj + '-' + ruleForm.menuMc}}</span>
          <span v-else-if="ruleForm.xtmc && !ruleForm.menuMc">{{ ruleForm.xtmc }}-首页</span>
          <span v-else-if="!ruleForm.xtmc && !ruleForm.menuMc">首页</span>
        </el-descriptions-item>
        <el-descriptions-item label="类型" label-align="right" align="left" width="100px" span="2"><span v-if="ruleForm.lx">{{ruleForm.lx.name}}</span></el-descriptions-item>
        <el-descriptions-item label="提出人" label-align="right" align="left" width="100px" span="2">{{ruleForm.tcr}}</el-descriptions-item>
        <el-descriptions-item label="提出时间" label-align="right" align="left" width="100px" span="2">{{ruleForm.tcsj}}</el-descriptions-item>
        <el-descriptions-item label="解决状态" label-align="right" align="left" width="100px" span="2"><span v-if="ruleForm.jjzt">{{ruleForm.jjzt.name}}</span></el-descriptions-item>
        <el-descriptions-item label="解决人" label-align="right" align="left" width="100px" span="2">{{ruleForm.jjr}}</el-descriptions-item>
        <el-descriptions-item label="解决时间" label-align="right" align="left" width="100px" span="2">{{ruleForm.jjsj}}</el-descriptions-item>
        <el-descriptions-item label="描述" label-align="right" align="left" width="100px" span="6">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.ms"></p>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/sys/xuqiu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
